import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/cdoc/addUser";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import { hideModal } from "../../../../../../store/actions/modal";

import { StateDto } from "../../../../../../types/states.dto";
import {
  addUserToCdoc,
  resetUpdateCDOCs,
  shareCdoc,
} from "../../../../../../store/actions/cdoc";
import { CDocDto } from "../../../../../../types/cdoc.dto";
import DinamicFieldListIn from "../../../../../../components/Form/DinamicFieldListIn";
import { UsersDto } from "../../../../../../types/users.dto";
import { AcademyDto } from "../../../../../../types/academy.dto";
import { CurrentDto } from "../../../../../../types/current.dto";
import { RoadmapDto } from "../../../../../../types/roadmap.dto";
import { shareRoadmap } from "../../../../../../store/actions/roadmap";
import { UserDto } from "../../../../../../types/user.dto";
import { fetchFilterUsersByAcademy } from "../../../../../../helpers/usersFromAcademies";

const Component = ({
  users,
  updateStates,
  roadmap,
  academies,
  current,
  user,
}: {
  users: UsersDto[];
  updateStates: StateDto;
  roadmap: RoadmapDto;
  academies: AcademyDto[];
  current: CurrentDto;
  user: UserDto;
}) => {
  const [currentUsers, setCurrentUsers] = useState<UsersDto[]>();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const [filteredValues, setFilteredValues] = useState<any>();
  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    for (const value of values.users) {
      dispatch(
        shareRoadmap({
          _id: roadmap._id,
          ...(value.field === "email" && { email: value.value }),
          ...(value.field === "username" && { username: value.value }),
        })
      );
    }

    setFormActions(actions);
  };

  useEffect(() => {
    if (updateStates.success) {
      toast.success("👌🏼 Cdoc publicado");

      setTimeout(() => {
        dispatch(resetUpdateCDOCs());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (updateStates.error) {
      toast.error(`😱 ${updateStates.error}`);

      setTimeout(() => {
        dispatch(resetUpdateCDOCs());
      }, 1000);
    }
  }, [updateStates]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchFilterUsersByAcademy({
        academyId: current.id,
        filterUsers: (user) => user.active && (user.username || user.email),
        filterUsersAcademy: (userFounded) =>
          userFounded.user !== user._id && !userFounded.roleEnd,
      });
      setCurrentUsers(response);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (currentUsers) {
      const filteredValues = currentUsers
        .map((user, index) => {
          const objUser = {
            userName: {
              ...(!!user.username && {
                label: user.username,
                value: {
                  id: user._id,
                  value: user.username,
                  field: "username",
                  role: "READER",
                },
              }),
            },
            email: {
              ...(!!user.email && {
                label: user.email,
                value: {
                  id: user._id,
                  value: user.email,
                  field: "email",
                  role: "READER",
                },
              }),
            },
          };

          return Object.values(objUser).filter(
            (obj) => Object.values(obj).length !== 0
          );
        })
        .flat(1);
      setFilteredValues(filteredValues);
    }
  }, [currentUsers]);

  return (
    <Modal name="share-user-roadmap" title={`Compartir Roadmap a usuarios`}>
      <Formik
        initialValues={initialValues({})}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="invite-academy-modal-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <DinamicFieldListIn
                    name="users"
                    error={errors["users"]}
                    touched={touched["users"]}
                    value={values["users"]}
                    onChange={handleChange}
                    valueFieldName="id"
                    onBlur={handleBlur}
                    pickFunction={(array, valuePicked, fieldName) => {
                      const firstResult = array.filter(
                        (item) =>
                          valuePicked[fieldName] === item.value[fieldName]
                      );

                      if (
                        firstResult[0].value["value"] !== valuePicked["value"]
                      ) {
                        return firstResult[1].value;
                      } else {
                        return firstResult[0].value;
                      }
                    }}
                    options={{
                      skin: "gray",
                      type: "select",
                      height: "95px",
                      setFieldValue: setFieldValue,
                      ...(!!filteredValues && {
                        data: filteredValues.map((user) => {
                          return { value: user.value, label: user.label };
                        }),
                      }),
                      externalData: true,
                      loading: !filteredValues,
                      inputLabel: "Seleccionar usuarios para Cdoc",
                      inputPlaceholder: "Selecciona un usuario",
                    }}
                  />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col>
                  <Center gap={"10px"}>
                    <Submit
                      isSubmmiting={isSubmitting}
                      form="invite-academy-modal-form"
                      color="Primary"
                      style={{ width: "170px" }}
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                    <Button
                      onClick={resetForm}
                      type="button"
                      options={{
                        type: "outline",
                        skin: "danger",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                      style={{ marginLeft: "10px", width: "170px" }}
                    >
                      Reestablecer
                    </Button>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({
  academyStore,
  cohortStore,
  currentStore,
  unitStore,
  usersStore,
  userStore,
}) => {
  const { data: academies } = academyStore.all;
  const { data: cohorts } = cohortStore.allCohorts;
  const { data: current } = currentStore;
  const { data: units } = unitStore.allUnits;
  const { states: updateStates } = unitStore.updateUnit;
  const { data: users } = usersStore.all;
  const { data: user } = userStore;
  return { updateStates, users, academies, current, user };
};

export default connect(states)(Component);
